import { dialog } from "../../../../nq-component";
import BaseListPresenter from "../../../../base/BaseListPresenter";
import DialogModal from "../../../../components/Dialog";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import { auditLogUseCase } from "../../../../usecases/logs";

class DirectPurchasePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
  ) {
    super(view, findObjectUseCase, deleteObjectUseCase);
    this.findObjectUseCase = findObjectUseCase;
    this.countObjectUseCase = countObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.upsertUseCase = upsertUseCase;
  }

  init() {
    const user = this.view.getCurrentUser();
    const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    const storeId = user?.storeAnalytic?.[0]?.id;
    this.where = hasAdminRole ? {} : { "storeId.id": { $eq: storeId } };
    // this.where = {};
    this.limit = 20;
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  async getObjects() {
    this.reset();
    await this.countObjects();
    await this.findObjects();
  }

  async countObjects() {
    try {
      this.showProgress();
      const collection = this.view.getCollectionName();
      const query = this.createQuery();
      const { count } = await this.countObjectUseCase.execute(collection, {
        where: query.where,
      });
      this.count = count;
      this.view.setCount(this.count);
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(this.objects);
      this.view.setCount(this.count);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  onClickAdd() {
    this.view.navigateTo("/collection/direct_purchaces/form");
  }

  async updateDirectPurchase(object, material) {
    dialog.close();
    this.view.showProgressDialog();
    const oldQty = object.quantity;
    const user = this.view.getCurrentUser();
    const unitCost = parseFloat(material.unit_cost || 0);
    const updatedQty = parseFloat(material.quantity || 0);
    const computedCost = (object.amountDirect * updatedQty).toFixed(2);
    const addedQtys = updatedQty - oldQty;

    object.quantity = String(updatedQty);
    object.price = computedCost;

    try {
      const responseDp = await upsertUseCase().execute(
        "direct_purchase",
        object,
      );

      // --- inventory update block ---
      const inventoryItem = await findObjectUseCase().execute("inventory", {
        where: {
          sku: material.sku,
          "storeId.id": { $eq: user?.storeAnalytic?.[0]?.id },
        },
        limit: 1,
      });

      let responseInv = null;
      if (inventoryItem?.length > 0) {
        const currentInventory = inventoryItem[0];
        const currentCount = parseFloat(currentInventory.systemCount || "0");
        const addedQty = parseFloat(material.quantity || "0");
        const updatedCount = currentCount + addedQtys;
        const isExistingCountBigger =
          material?.quantiyBeforeAdjust > material?.quantity;
        const differenceQty =
          material?.quantity - material?.quantiyBeforeAdjust;

        // console.log("differenceQty", String(differenceQty));

        // console.log("isExistingCountBigger", isExistingCountBigger);
        // console.log("object", object);
        // console.log("current inventory:", currentInventory);
        // console.log("updated", {
        //   id: currentInventory.id,
        //   systemCount: String(updatedCount),
        // });

        responseInv = await this.upsertUseCase.execute("inventory", {
          id: currentInventory.id,
          systemCount: String(updatedCount),
        });

        await this._saveReceivableTransaction({
          storeId: { id: user?.storeAnalytic?.[0]?.id },
          sku: material.sku,
          item_name: material.itemName,
          transaction_type: "Direct Purchase",
          quantity: String(differenceQty),
          business_date: new Date().toISOString(),
          reference_id: responseDp?.id,
        });

        await auditLogUseCase().create({
          user: { id: user.id },
          logDate: new Date().toISOString(),
          message: `Added ${addedQty} to inventory: ${material.itemName}, old stock: ${currentCount}, new stock: ${updatedCount}`,
          collection: "inventory",
          objectId: currentInventory.id,
          payload: {
            material,
            responseInv,
          },
          store: { id: user.storeAnalytic?.[0]?.id },
        });
      }

      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: new Date().toISOString(),
        message: `Saved direct purchase for ${material.itemName}, quantity: ${material.quantity}, total cost: ${material.cost}`,
        collection: "direct_purchase",
        objectId: responseDp.id,
        payload: {
          material,
          response: responseDp,
          responseInv,
        },
        store: { id: user.storeAnalytic?.[0]?.id },
      });
      this.view.hideProgressDialog();
      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              //   this.view.navigateBack();
              dialog.close();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
      this.change = {};
      this.getObjects();
    } catch (error) {
      throw error;
    }
  }

  async _saveReceivableTransaction(inventoryItem) {
    try {
      // const payload = {
      //   storeId: { id: storeId },
      //   sku: material.sku,
      //   item_name: material.itemName,
      //   transaction_type: "Direct Purchase",
      //   quantity: String(material.quantity),
      //   business_date: new Date().toISOString(),
      //   reference_id: directPurchaseResponse?.id,
      // };

      await this.upsertUseCase.execute("inventory_transaction", inventoryItem);
    } catch (error) {
      throw error;
    }
  }

  onClickEdit(index) {
    const object = this.objects[index];
    const material = object.raw_materials?.[0] || {};
    console.log("object", object, "material", material);

    const unitCost = parseFloat(material?.unit_cost || 0);
    const priceCost = parseFloat(object?.price || 0);
    const amountDirect = parseFloat(object?.amountDirect || 0);
    const initialQty = parseFloat(object?.quantity || 0);
    const costRefId = "cost-display"; // unique ID for cost display span

    let updatedQty = initialQty;
    console.log("u", updatedQty);

    dialog.fire({
      html: (
        <div className="m-2">
          <p className="mb-1 mt-2 fw-bold">Adjust Item</p>
          <hr />
          <table className="table table-bordered">
            <thead
              style={{
                backgroundColor: "#82c14a",
                color: "white",
              }}
            >
              <tr>
                <th
                  style={{
                    backgroundColor: "#82c14a",
                    color: "white",
                  }}
                >
                  SKU
                </th>
                <th
                  style={{
                    backgroundColor: "#82c14a",
                    color: "white",
                  }}
                >
                  Amount
                </th>
                <th
                  style={{
                    backgroundColor: "#82c14a",
                    color: "white",
                  }}
                >
                  Qty
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{material.sku}</td>
                <td>
                  ₱
                  <span id={costRefId}>
                    {/* {(priceCost * initialQty).toFixed(2)} */}
                    {priceCost.toFixed(2)}
                  </span>
                </td>
                <td>
                  <input
                    type="number"
                    min="1"
                    className="form-control"
                    style={{ width: "100px", margin: "0 auto" }}
                    defaultValue={initialQty}
                    onInput={(e) => {
                      updatedQty = parseFloat(e.target.value || 0);
                      const newCost = (amountDirect * updatedQty).toFixed(2);
                      document.getElementById(costRefId).textContent = newCost;
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <div className="card p-2">
            <p className="mt-1 mb-1">
              <strong>Name:</strong> {material.itemName}
            </p>
            <p className="mb-1">
              <strong>Description:</strong> {object.description || "—"}
            </p>
          </div>

          <div className="d-flex justify-content-center gap-2 mt-4">
            <button
              className="btn"
              onClick={() => dialog.close()}
              style={{ backgroundColor: "#d1d1d1" }}
            >
              Cancel
            </button>
            <button
              className="btn btn-success text-white"
              onClick={() =>
                this.updateDirectPurchase(object, {
                  ...material,
                  quantiyBeforeAdjust: initialQty,
                  quantity: updatedQty,
                  cost: (amountDirect * updatedQty).toFixed(2),
                })
              }
            >
              Save
            </button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  onClickView(index) {
    const object = this.objects[index];
    this.view.navigateTo("/collection/direct_purchaces/form/" + object.id);
  }

  async onClickDelete(index) {
    dialog.close();
    const object = this.objects[index];
    const collection = this.view.getCollectionName();

    await this.deleteObjectUseCase.execute(collection, object.id);
    // const indexes = this.objects.indexOf(object.id);
    // this.objects.splice(indexes, 1);
    // this.view.setObjects(this.objects);
    this.objects.splice(index, 1);
    this.view.setObjects([...this.objects]); // spread to trigger updates if needed

    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Deleted Successfully"
          message=""
          isCancelButton={false}
          onSubmit={() => {
            dialog.close();
          }}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }
  onClickImport() {}
  onClickExport() {}
}

export default DirectPurchasePresenter;
